import React from 'react';
import { Formik } from 'formik';
import { Modal, ModalBody, ModalContent, ModalOverlay } from '@chakra-ui/react';
import useUpdateInspectionStatusUseCase from '../../../../hooks/usecases/inspections/useUpdateInspectionStatusUseCase';
import { localise } from '../../../../services/lang/lang';
import { RenderIf } from '../../../modules/RenderIf/RenderIf';
import { ErrorAwareAlertBox } from '../../../modules/ErrorAwareAlertBox/ErrorAwareAlertBox';
import StandardModalHeader from '../../../modules/Modal/StandardModalHeader';
import UpdateInspectionStatusFormWrapper from './UpdateInspectionStatusFormWrapper';
import SuspenseWrapper from '../../../modules/SuspenseWrapper/SuspenseWrapper';
const UpdateInspectionStatusModal = ({ inspection, isOpen, onClose, onSuccess, }) => {
    const initialFormValues = {
        statusId: inspection.status.id,
    };
    const useCase = useUpdateInspectionStatusUseCase(inspection, onSuccess);
    return (React.createElement(Modal, { "data-testid": "update_inspection_status_modal__modal", variant: "primary", isOpen: isOpen, onClose: onClose },
        React.createElement(ModalOverlay, null),
        React.createElement(ModalContent, { w: 500, tabIndex: -1 },
            React.createElement(StandardModalHeader, { title: localise('CHANGE_STATUS') }),
            React.createElement(ModalBody, null,
                React.createElement(SuspenseWrapper, null,
                    React.createElement(RenderIf, { condition: useCase.isError },
                        React.createElement(ErrorAwareAlertBox, { error: useCase.error })),
                    React.createElement(Formik, { onSubmit: useCase.execute, initialValues: initialFormValues },
                        React.createElement(UpdateInspectionStatusFormWrapper, { onClose: onClose })))))));
};
export default UpdateInspectionStatusModal;
